import { defineStore } from 'pinia'
import {
  HotelRefundability,
  type SearchPanelHotelOptions,
} from '@/modules/Search/types'
import { HotelMealsIncluded, HotelRoomType } from '@/modules/Search/types'

function initState(): { options: SearchPanelHotelOptions } {
  return {
    options: {
      mealsIncluded: HotelMealsIncluded.Any,
      roomType: HotelRoomType.Any,
      starRating: -1,
      refundability: HotelRefundability.Any,
    },
  }
}

const useHotelSearchOptions = defineStore('hotelSearchOptions', {
  state: () => ({ ...initState() }),
  actions: {
    setOptions(payload: Partial<SearchPanelHotelOptions>) {
      this.options = {
        ...this.options,
        ...payload,
      }
    },
    resetOptions() {
      this.options = initState().options
    },
  },
})

export default useHotelSearchOptions
